import { FreeBetWinningType, getAmountWithCurrency, toFixed } from '@pascal/pascal-core';
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { gameStore } from '../../store';

export const CurrentAmount = observer(({ item, currentJetsInfo, limits, isDemo }) => {
  const [maxHalfAmount, setMaxHalfAmount] = useState(null);
  const { showMaxWinPopUpData } = gameStore;
  const odd = currentJetsInfo[item.fighterNumber];
  const betAmount = item.isHalfCashOut ? item.amount / 2 : item.amount;
  useEffect(() => {
    if (!maxHalfAmount && item.isHalfCashOut && showMaxWinPopUpData[item.fighterNumber]) {
      setMaxHalfAmount(limits.maxWin - item.halfWinAmount);
    }
  }, [showMaxWinPopUpData[item.fighterNumber]]);
  // const { freeBetType } = doBetStore.betData;

  // const amount =
  //   maxHalfAmount || FreeBetWinningType.Win
  //     ? maxHalfAmount
  //     : odd * betAmount >= (item.freeBetId ? item.freeBetMaxPayout : limits.maxWin)
  //     ? item.freeBetId
  //       ? item.freeBetMaxPayout
  //       : limits.maxWin
  //     : odd * betAmount;
  let amount;

  if (maxHalfAmount) {
    amount = maxHalfAmount;
  } else if (
    odd * betAmount >=
    (item.freeBetId ? item.freeBetMaxPayout || limits.maxWin : limits.maxWin)
  ) {
    if (item.freeBetId) {
      amount = item.freeBetMaxPayout || limits.maxWin;
    } else {
      amount = limits.maxWin;
    }
  } else {
    amount = odd * betAmount;
  }
  return (
    <span className='big-btn-cash-out-num-text'>
      {getAmountWithCurrency({
        amount: toFixed(+amount),
        isShowRealCurrency: !isDemo,
      })}
    </span>
  );
});
